import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessHypothekReportParamStatus: 'idle',
    startProcessHypothekReportParamError: undefined as any,
    loadUserParamsProcessHypothekReportParamStatus: 'idle',
    loadUserParamsProcessHypothekReportParamError: undefined as any,

    processHypothekReportParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessHypothekReportParam = createAsyncThunk('processHypothekReportParamSlice/startProcessHypothekReportParam', async ({ processHypothekReportParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessHypothekReportParam/`,
        prepareData(processHypothekReportParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessHypothekReportParamStatus } = getState().processHypothekReportParamSlice
        return startProcessHypothekReportParamStatus !== 'pending'
    }
})

export const loadUserParamsProcessHypothekReportParam = createAsyncThunk('processHypothekReportParamSlice/loadUserParamsProcessHypothekReportParam', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessHypothekReportParam/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessHypothekReportParamStatus } = getState().processHypothekReportParamSlice
        return loadUserParamsProcessHypothekReportParamStatus !== 'pending'
    }
})

const ProcessHypothekReportParamSlice = createSlice({
    name: 'processHypothekReportParamSlice',
    initialState,
    reducers: {
        resetstartProcessHypothekReportParam: (state) => {
            state.job = undefined
            state.startProcessHypothekReportParamError = undefined
        },
        resetstartProcessHypothekReportParamError: (state) => {
            state.startProcessHypothekReportParamError = undefined
        },
        resetloadUserParamsProcessHypothekReportParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessHypothekReportParamError = undefined
        },
        resetloadUserParamsProcessHypothekReportParamError: (state) => {
            state.loadUserParamsProcessHypothekReportParamError = undefined
        },
        removeFromProcessHypothekReportParamListById: (state, action) => {
            state.processHypothekReportParamList = state.processHypothekReportParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessHypothekReportParamListByIds: (state, action) => {
            state.processHypothekReportParamList = state.processHypothekReportParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processHypothekReportParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessHypothekReportParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processHypothekReportParamList = []
            state.startProcessHypothekReportParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessHypothekReportParam.pending, (state) => {
            state.startProcessHypothekReportParamStatus = 'pending'
            state.startProcessHypothekReportParamError = undefined
        })
        builder.addCase(startProcessHypothekReportParam.fulfilled, (state, action) => {
            state.startProcessHypothekReportParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessHypothekReportParam.rejected, (state, action) => {
            state.startProcessHypothekReportParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessHypothekReportParamError = action.error.message
            } else {
                state.startProcessHypothekReportParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessHypothekReportParam.pending, (state) => {
            state.loadUserParamsProcessHypothekReportParamStatus = 'pending'
            state.loadUserParamsProcessHypothekReportParamError = undefined
        })
        builder.addCase(loadUserParamsProcessHypothekReportParam.fulfilled, (state, action) => {
            state.loadUserParamsProcessHypothekReportParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessHypothekReportParam.rejected, (state, action) => {
            state.loadUserParamsProcessHypothekReportParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessHypothekReportParamError = action.error.message
            } else {
                state.loadUserParamsProcessHypothekReportParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessHypothekReportParam,
    resetstartProcessHypothekReportParamError,
    resetloadUserParamsProcessHypothekReportParam,
    resetloadUserParamsProcessHypothekReportParamError,
    removeFromProcessHypothekReportParamListById,
    removeFromProcessHypothekReportParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessHypothekReportParamSlice.actions
export default ProcessHypothekReportParamSlice.reducer
